// @flow
import {
  folderType,
  type FolderTypes,
  contentType,
  type ContentTypes,
  type Content,
  type FolderContentsItemsCount,
  type FolderItemsCount,
} from '../types';

import {
  formatText,
  formatNumber,
} from '../utils';
import {
  getSmartFolderTitle,
} from '../smartfolders/utils';
import {
  isEmptyList,
} from '../simpleUtils';

const getContentItemText = (c: ContentTypes, itemsCount: number,
  contentsItemsCount?: FolderContentsItemsCount) => {
  switch (c) {
    case contentType.STUDY_SET:
      return formatText(itemsCount, 'fact');
    case contentType.QUESTION_SET:
      return formatText(itemsCount, 'question');
    case contentType.FOLDER:
      if (itemsCount === 0 && !contentsItemsCount) {
        return 'Folder Items';
      } if (contentsItemsCount) {
        const {
          numFacts,
          numQuestions,
        } = contentsItemsCount;
        const data = [...(numFacts ? [{
          label: 'facts',
          count: numFacts,
        }] : []),
        ...(numQuestions ? [{
          label: 'questions',
          count: numQuestions,
        }] : [])];
        const text = !isEmptyList(data) ? data.map(({ label, count }) => `${formatNumber(count)} ${label}`).join(' | ') : '0 ITEMS';
        return text;
      }
      return 'Items';

    default:
      return 'Content';
  }
};

const getSmartFolderDesc = (type?: FolderTypes) => {
  switch (type) {
    case folderType.Favorites:
      return 'Your favorited study sets, practice tests, folders, and Study-Packs';
    case folderType.Created:
      return 'Your created study sets, practice tests, and folders';
    case folderType.StudyPacks:
      return 'Your premium Study-Packs';
    case folderType.Recent:
      return 'Your recently studied content';
    case folderType.Shared:
      return 'Your shared content';
    default:
      return null;
  }
};
const getContentTitleAndDescription = (smartFolderType: FolderTypes,
  content: Content) => {
  if (smartFolderType) {
    return {
      title: getSmartFolderTitle(smartFolderType),
      description: getSmartFolderDesc(smartFolderType),
    };
  }
  return {
    title: content.name,
    description: content.description,
  };
};
const getItemsCount = (type: ContentTypes, itemsCount: FolderItemsCount,
  accessFolderItemsCount?: boolean) => {
  if (!itemsCount) {
    return 0;
  }
  const {
    numFacts,
    numQuestions,
    numQuestionSets,
    numFolders,
    numStudySets,
  } = itemsCount;
  switch (type) {
    case contentType.STUDY_SET:
      return numFacts;
    case contentType.QUESTION_SET:
      return numQuestions;
    case contentType.FOLDER:
      return accessFolderItemsCount
        ? numFacts + numQuestions
        : numQuestionSets + numFolders + numStudySets;
    case contentType.BUNDLE:
      return numFacts + numQuestions;
    default:
      return 0;
  }
};

export {
  getContentItemText,
  getSmartFolderDesc,
  getContentTitleAndDescription,
  getItemsCount,
};
